import { Icon, IconProps } from "@chakra-ui/react";

const PlayIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.524 4.93734L19.616 11.1473C19.7616 11.2368 19.8818 11.3621 19.9653 11.5113C20.0487 11.6604 20.0925 11.8285 20.0925 11.9993C20.0925 12.1702 20.0487 12.3383 19.9653 12.4874C19.8818 12.6366 19.7616 12.7619 19.616 12.8513L9.524 19.0613C9.37245 19.1546 9.19878 19.2057 9.02088 19.2094C8.84299 19.2131 8.66733 19.1693 8.51202 19.0825C8.35672 18.9957 8.22739 18.869 8.13738 18.7155C8.04737 18.562 7.99995 18.3873 8 18.2093V5.78934C7.99995 5.61141 8.04737 5.43669 8.13738 5.28321C8.22739 5.12972 8.35672 5.00303 8.51202 4.91621C8.66733 4.82938 8.84299 4.78556 9.02088 4.78928C9.19878 4.793 9.37245 4.84411 9.524 4.93734Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default PlayIcon;
